module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightcloud-3b1f0641bc2a4c9d8db470d58244fc03.webp";